import { render, staticRenderFns } from "./React.vue?vue&type=template&id=69d28ac2&"
import script from "./React.vue?vue&type=script&lang=js&"
export * from "./React.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports